import { render, staticRenderFns } from "./DuigongStock.vue?vue&type=template&id=97844efe&scoped=true&"
import script from "./DuigongStock.vue?vue&type=script&lang=js&"
export * from "./DuigongStock.vue?vue&type=script&lang=js&"
import style0 from "./DuigongStock.vue?vue&type=style&index=0&id=97844efe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97844efe",
  null
  
)

export default component.exports